import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select'

export default class extends Controller {
  static values = { noResults: String }

  connect () {
    this.selectInstance = new TomSelect(this.element, {
      allowEmptyOption: false,
      closeAfterSelect: true,
      onItemAdd: () => this.selectInstance.blur(),
      ...this.#localisedEmptyMessage()
    })
  }

  // Opt-in: TomSelect's own empty line is the English "No results found", which is wrong on a
  // Ukrainian page. A caller that passes data-select-no-results-value gets its own wording;
  // one that does not is left on TomSelect's default, unchanged.
  //
  // Built with textContent rather than a template literal — the value is ours, from a locale
  // file, but this widget's whole point is a box a stranger types into.
  #localisedEmptyMessage () {
    if (!this.hasNoResultsValue) return {}

    const text = this.noResultsValue

    return {
      render: {
        no_results: () => {
          const element = document.createElement('div')

          element.className = 'no-results'
          element.textContent = text

          return element
        }
      }
    }
  }

  disconnect () {
    this.selectInstance?.destroy()
  }
}
